import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { useFormContext } from "react-hook-form";

import { PHONE_LENGTH_BY_COUNTRY } from "@/constants/countries.constants";
import { PhoneInput } from "@/components/ui/phone-input";
import { TCreateDealFormData } from "../add.deal.sidebar";

const DealLeadPhoneField = () => {
  const { control, watch } = useFormContext<TCreateDealFormData>();

  const country = watch("phoneCountryCode");
  const leadId = watch("leadId");

  const rule = PHONE_LENGTH_BY_COUNTRY[country];
  const maxLength = rule?.max ?? 15;

  return (
    <FormItem>
      <FormLabel className="mb-2 block text-[10.5px] font-medium uppercase tracking-[0.12em] text-slate-500">
        Lead Phone Number
      </FormLabel>

      <div className="flex">
        <FormField
          control={control}
          name="phone"
          render={({ field: phoneField }) => (
            <FormField
              control={control}
              name="phoneCountryCode"
              render={({ field: countryField }) => (
                <FormItem className="w-full">
                  <FormControl>
                    <PhoneInput
                      countryValue={countryField.value}
                      phoneValue={phoneField.value || ""}
                      maxLength={maxLength}
                      readOnly={!!leadId}
                      onCountryChange={(iso) => {
                        countryField.onChange(iso);
                      }}
                      onPhoneChange={phoneField.onChange}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
          )}
        />
      </div>

      <FormMessage className="text-[10.5px] text-accent-red" />
    </FormItem>
  );
};

export default DealLeadPhoneField;
